<template>
  <div class="fts-design-tool-container">
    <div class="insert-text fts-badge badge-primary badge-xs">NEW</div>
    <div class="fts-design-tool-item" :class="{ 'design-tool-item--disabled': disabled }">
      <div v-if="item.input=='description'" class="tool-item">Content</div>

      <div v-else-if="item.input=='image'" class="tool-item">Image</div>

      <div v-else-if="item.input=='empty'" class="tool-item">
        Empty Space <span class="tool-item-emoji">🙈</span>
      </div>

      <div v-else-if="item.input=='readOnly'" class="tool-item">Read Only</div>

      <div v-else-if="item.input=='button'" class="tool-item">Button</div>

      <div v-else-if="item.custom==true" class="tool-item">      
        <!-- only when from classification -->
        <div class="element-wrapper" v-if="item.id">
          <div class="element-info-wrapper">
            <i class="element-icon" :class="getIcon(item.type)"></i>
            <div class="element-display-name">{{item.displayName}}</div>
            <font-awesome-icon v-if="!disabled"
              class="element-remove"
              :icon="['fas', 'times']"
              fixedWidth
              @click="remove()"
            />
          </div>
        </div>
        <div class="element-custom" :class="{'classification': item.id && item.displayName}">Control/Input</div>
      </div>

      <div v-else-if="item.input === 'section'" class="tool-item">{{item.type || 'Section'}}</div>

      <div v-else class="element-wrapper">
        <div class="element-info-wrapper">
          <i class="element-icon" :class="getIcon(item.type)"></i>
          <div class="element-display-name">{{item.displayName}}</div>
          <font-awesome-icon v-if="!disabled && !disabledRemove"
            class="element-remove"
            :icon="['fas', 'times']"
            fixedWidth
            @click="remove()"
          />
        </div>

        <div v-if="item.type === 14 || item.type == 15" class="element-table-container">
          <template v-for="column in item.columns">
            <div class="element-info-wrapper" :key="column.id">
              <i class="element-icon" :class="getIcon(column.type)"></i>
              <span class="element-display-name">{{column.displayName}}</span>
            </div>

            <div
              v-if="item.type == 15"
              class="element-table-container"
              :key="`columns-${column.id}`"
            >
              <div
                v-for="columnItem in column.columns"
                :key="columnItem.id"
                class="element-info-wrapper"
              >
                <i class="element-icon" :class="getIcon(columnItem.type)"></i>
                <span class="element-display-name">{{columnItem.displayName}}</span>
              </div>
            </div>
          </template>
        </div>
      </div>

      <fts-release-badge v-if="item.beta" />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import wysiwyg from "../vue-wysiwyg/src/editor/index";
import commons from "../commons/commons";

Vue.use(wysiwyg, {});

export default {
  data() {
    return {};
  },
  props: {
    item: Object,
    disabled: Boolean,
    disabledRemove: Boolean
  },
  computed: {
    hiddenColumns() {
      return this.item.fields.filter(x => x.hide);
    },
    shownColumns() {
      return this.item.fields.filter(x => !x.hide);
    }
  },
  methods: {
    remove() {
      this.$emit("remove", this.item);
    },
    getIcon(typeId) {
      return commons.informationIcon(typeId);
    },
    hide(column) {
      if (column.hide == null) Vue.set(column, "hide", true);
      column.hide = true;
    },
    unhide(column) {
      column.hide = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.fts-design-tool-container {
  display: block;
}

.insert-text {
  display: none;
}

.disabled {
  opacity: 0.4;
}

.element-custom {
  &.classification {
    margin-top: .175rem;
    color: var(--fts-default);
    font-size: 85%;
  }
}
</style>